import { Table } from 'dexie';
import db, { Database } from '@/db';
import { UserSessionModel } from '../models';

export type TABLE_TYPE = Table<UserSessionModel>;
const TABLE = 'userSession';
const SCHEMA = 'id'; // Use `id` as primary key

class UserSessionDatabase {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  save(session: UserSessionModel) {
    return this.db[TABLE].put(session);
  }

  async load(): Promise<UserSessionModel | undefined> {
    const users = await this.db[TABLE].toArray();
    let user: UserSessionModel | undefined = undefined;
    if (users.length > 0) {
      user = users[0];
    }

    return user;
  }

  async clear() {
    await this.db[TABLE].clear();
  }
}

export const UserSessionDB = new UserSessionDatabase(db);
